<template>
  <modal-select
    v-model="valueDirty"
    :items="filteredYachts"
    :loading="yachts.loading"
    item-text="name"
    :dialog-title="dialogTitle"
    :multiple="multiple"
    :force-dialog="forceDialog"
    :dialog-only="dialogOnly"
    :dialog-visible.sync="dialogVisibleDirty"
    :error-messages="errorMessagesComputed"
    v-bind="$attrs"
    @opened="focusSearch"
    @submit="$emit('submit')"
  >
    <template
      v-if="!dialogOnly"
      v-slot:dropdownSelectItem="{ item: yacht }"
    >
      <v-list-item-avatar
        color="indigo"
        class="headline font-weight-light white--text"
      >
        <img
          v-if="yacht.model.main_image"
          :src="yacht.model.main_image.path"
        >
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title :class="{ 'grey--text': !yacht.name }">
          {{ yacht.name || 'n/a' }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ yacht.model.full_label }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:filters>
      <v-row no-gutters>
        <v-col cols="8">
          <v-select
            v-model="filters.yachtTypeId"
            class="mb-1"
            solo
            label="Search by type"
            clearable
            :items="$store.state.settings.yachtTypes.data"
            :loading="$store.state.settings.yachtTypes.loading"
            hide-details
            item-value="id"
            item-text="label"
          />
        </v-col>
        <v-col cols="8">
          <v-text-field
            ref="nameSearch"
            v-model="filters.name"
            placeholder="Search by name"
            clearable
            hide-details
            autocomplete="disable"
            solo
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:dialogItem="{ item: yacht, selected: selected, selectItem: selectItem }">
      <v-list-item
        :key="yacht.id"
        class="list--bordered"
        :class="{ 'grey lighten-4': selected }"
        @click="selectItem(yacht)"
      >
        <v-list-item-avatar
          color="indigo"
          class="headline font-weight-light white--text"
        >
          <v-img
            v-if="yacht.model.main_image"
            :src="yacht.model.main_image.path"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title :class="{ 'grey--text': !yacht.name, 'primary--text font-weight-bold': selected }">
            {{ yacht.name || 'n/a' }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ yacht.model.full_label }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="selected">
          <v-avatar
            color="success"
            size="26px"
          >
            <v-icon
              color="white"
              small
            >
              check
            </v-icon>
          </v-avatar>
        </v-list-item-action>
      </v-list-item>
    </template>
    <template v-slot:noData>
      No yachts currently
    </template>
  </modal-select>
</template>

<script>
import ModalSelect from '@/components/helpers/ModalSelect'
import { mapState } from 'vuex'

export default {
    name: 'YachtModalSelect',
    components: { ModalSelect },
    props: {
      value: {
        type: [Object, Array],
        default: null
      },
      multiple: {
        type: Boolean,
        default: false
      },
      dialogTitle: {
        type: String,
        default: 'Select yacht'
      },
      forceDialog: {
        type: Boolean,
        default: false
      },
      dialogOnly: {
        type: Boolean,
        default: false
      },
      dialogVisible: {
        type: Boolean,
        default: false
      },
      errorMessages: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        filters: {
          name: null,
          yachtTypeId: null
        }
      }
    },
    computed: {
      valueDirty: {
        set: function (value) {
          this.$emit('input', value)
        },
        get: function () {
          return this.value
        }
      },
      dialogVisibleDirty: {
        set: function (value) {
          this.$emit('update:dialogVisible', value)
        },
        get: function () {
          return this.dialogVisible
        }
      },
      errorMessagesComputed() {
        // this hack is needed to prevent re-rendering (Vue bug)
        // https://github.com/vuejs/vue/issues/4060
        return this.errorMessages
      },
      filteredYachts() {
        return this.yachts.data
          .filter(yacht => {
            return this.filters.yachtTypeId ? yacht.model.yacht_type_id === this.filters.yachtTypeId : true
          })
          .filter(yacht => {
            return this.filters.name ? (yacht.name && yacht.name.toLocaleLowerCase().includes(this.filters.name.toLocaleLowerCase())) : !!yacht.name
          })
      },
      ...mapState('settings', ['yachtTypes']),
      ...mapState('service', ['yachts'])
    },
    mounted() {
      if (this.yachts.data.length === 0 && !this.yachts.loading) this.$store.dispatch('service/fetchYachts')
    },
    methods: {
      focusSearch() {
        this.$refs.nameSearch.$el.querySelector('input').focus()
      },
      dialogClosed() {
        this.$emit('closed')
      }
    }
  }
</script>

<style scoped>

</style>
